<template>
  <div
    class="py-2"
  >
    <v-row class="pl-5 mt-n3 font-calibri font-16 font-weight-bold border-bottom-light-grey accordion-max-height">
      <v-col>
        Cost Center
        <span>
          <setup-companies-cost-centers-dialog-create
            v-if="$hasPermissionTo(['create cost centers'])"
            :company-id="company.id"
            :selected-company-name="company.name"
            @created="loadCostCenters(company.id)"
          />
        </span>
      </v-col>
    </v-row>
    <v-row class="mb-n10 font-calibri">
      <v-col>
        <v-data-table
          :items="costCenters"
          :headers="costCenterHeaders"
          hide-default-footer
          :items-per-page="-1"
          dense
          class="mt-2"
          :loading="loading"
        >
          <template v-slot:item.address="{ item }">
            <div>
              <span>{{ constructAddress(item) ? constructAddress(item) : '-' }}</span>
            </div>
          </template>

          <template v-slot:item.action="{ item }">
            <setup-companies-cost-centers-dialog-edit
              v-if="$hasPermissionTo(['update cost centers']) && !company.deleted_at"
              :cost-center="item"
              :selected-company-name="company.name"
              @updated="loadCostCenters(item.selected_company_uid)"
            />
               
            <setup-companies-cost-centers-dialog-delete
              v-if="$hasPermissionTo(['delete cost centers']) && !company.deleted_at"
              :cost-center="item"
              @deleted="loadCostCenters(item.selected_company_uid)"
            />
          </template>
          <v-spacer />
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {  
    components: {
      SetupCompaniesCostCentersDialogCreate: () => import('@/components/hris/setup/companies/cost-centers/DialogCreate'),
      SetupCompaniesCostCentersDialogEdit: () => import('@/components/hris/setup/companies/cost-centers/DialogEdit'),
      SetupCompaniesCostCentersDialogDelete: () => import('@/components/hris/setup/companies/cost-centers/DialogDelete'),
    },
    props: {
      company: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        costCenterHeaders: [
          {
            text: 'Cost Center Name',
            align: 'left',
            value: 'name',
          },
          {
            sortable: false,
            text: 'Actual Company / Belongs To',
            align: 'left',
            value: 'actual_company.name',
          },
          {
            sortable: false,
            text: 'Address',
            align: 'left',
            value: 'address',
          },
          {
            sortable: false,
            text: '',
            align: 'center',
            value: 'action',
          },
        ],
        costCenters: [],
      }
    },
    watch: {
      company: function (value) {
        if (!value) return
        this.refreshData()
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      refreshData () {
        this.loadCostCenters(this.company.id)
      },

      loadCostCenters (companyId) {
        this.loading = true
        
        this.$api.costCenters().list(companyId)
          .then(res => {
            this.costCenters = _.orderBy(res.data, ['name'], ['asc'])
            this.loading = false
          })
      },

      constructAddress (item) {
        return (item.address_line_one ? item.address_line_one + ',' : '') + (item.address_line_two ? item.address_line_two + ',' : '') + 
          (item.address_line_three ? item.address_line_three + ',' : '') + (item.postcode ? item.postcode + ',' : '') +
          (item.city ? (item.city || {}).name + ', ' : '') + (item.city ? ((item.city || {}).state || {}).name + ', ' : '') +
          (item.city ? (((item.city || {}).state || {}).country || {}).name : '')
      },
    },
  }
</script>

<style scoped>
.border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}

.font-calibri {
    font-family: Calibri !important;
}

.font-16 {
    font-size:16px;
}

.accordion-max-height {
  max-height: 36px !important;
}
</style>
